"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const prismic_reactjs_1 = require("prismic-reactjs");
const register_panel_styled_1 = require("./register-panel.styled");
const devRegisterIframeUrl = 'https://account-dev.travelnest.com/register.html';
exports.RegisterPanel = (props) => {
    return React.createElement(register_panel_styled_1.StyledRegisterPanel, Object.assign({}, Object.assign({}, props, { backgroundColour: props.backgroundColour || '#ffffff' })),
        React.createElement("h2", { className: "register-panel__heading" }, props.heading),
        props.subHeading && React.createElement("h3", { className: "register-panel__subheading" }, props.subHeading),
        React.createElement("hr", { className: "register-panel__heading-separator" }),
        React.createElement("div", { className: "register-panel__flex-content" },
            React.createElement("div", { className: "register-panel__lhs-content" },
                typeof props.textContent === 'string' ?
                    React.createElement("p", null, props.textContent) :
                    React.createElement("div", { className: "register-panel__rich-text" },
                        React.createElement(prismic_reactjs_1.RichText, { render: props.textContent })),
                props.cta &&
                    React.createElement("div", { className: "register-panel__cta-wrapper" },
                        React.createElement("a", { className: "register-panel__cta-button", href: props.cta.url, id: 'register-panel-cta' }, props.cta.text))),
            React.createElement("div", { className: "register-panel__rhs-content" },
                React.createElement("iframe", { className: "register-panel__register-iframe", src: props.registerIframeUrl || devRegisterIframeUrl, frameBorder: "0", sandbox: "allow-forms allow-scripts allow-top-navigation allow-same-origin" }))));
};
//# sourceMappingURL=RegisterPanel.js.map